import * as React from "react";
import classnames from "classnames";
/* empty css                               */
const PasswordStrengthIndicator = ({ strength, label, showStrength }) => /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
  "div",
  {
    className: classnames(
      "password-strength-indicator",
      showStrength && `password-strength-indicator--${strength}`
    )
  },
  /* @__PURE__ */ React.createElement("div", { className: "password-strength-indicator__item" }),
  /* @__PURE__ */ React.createElement("div", { className: "password-strength-indicator__item" }),
  /* @__PURE__ */ React.createElement("div", { className: "password-strength-indicator__item" }),
  /* @__PURE__ */ React.createElement("div", { className: "password-strength-indicator__item" })
), /* @__PURE__ */ React.createElement("div", { className: "password-strength-label" }, showStrength && label));
export {
  PasswordStrengthIndicator as default
};
//# sourceMappingURL=PasswordStrengthIndicator.js.map
